import './Contato.css'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';


const Contato = ()=>{
    return(
        <section className='side'>
            <a className="side-nav"href="#inicio">/inicio</a>
            <a className="side-nav" href="#sobremim">/sobremim</a>
            <a className="side-nav" href="#experiencia">/experiencia</a>
            <a className="side-nav" href="#projetos">/projetos</a>
            
            <div className='icones'>

                <a href="mailto:jfigueiredo07@hotmail.com" ><EmailRoundedIcon style={{ fontSize: 26 }}></EmailRoundedIcon></a>
                <a target='blank' href='https://github.com/fgrdz'><GitHubIcon style={{ fontSize: 25 }}></GitHubIcon></a>
                <a target='blank'href='https://www.linkedin.com/in/julio-figueiredo-237401256/'> <LinkedInIcon style={{ fontSize: 27 }}></LinkedInIcon></a>
            </div>
        </section>
            
    )
}

export default Contato;
